module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0040.29d854d0.jpg";